import { render, staticRenderFns } from "./productConsumIndex.vue?vue&type=template&id=0490f1b4"
import script from "./productConsumIndex.vue?vue&type=script&lang=js"
export * from "./productConsumIndex.vue?vue&type=script&lang=js"
import style0 from "./productConsumIndex.vue?vue&type=style&index=0&id=0490f1b4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports